import React, { Component } from 'react';
import { StampTODate, parseMSIntoReadableTime } from '../../lib/dtconv';
import { Row, ListGroupItem, Table } from 'react-bootstrap/lib';
const { DAY } = require('../../lib/enums');

export default class DailyStatsTiles extends Component {
  constructor(props) {
    super(props);
    this.dailyStatsTiles = [];
    this.createStatsTiles(this.props.dailyStats);
  }

  createStatsTiles(dailyStats) {
    this.dailyStatsTiles = [];
    var dt, midnight;
    if (dailyStats && dailyStats.length) {
      dailyStats.forEach((stat) => {
        dt = new Date(stat.ts)
        midnight = new Date().setHours(0, 0, 0, 0);
          this.dailyStatsTiles.push({
            stat: stat, table:
              <div>
                <div className="font-size16px padding-left1 color-9b9b9b">{stat.vid ? this.props.vehMap[stat.vid] : null}</div>
                <div className="font-size20px padding-left1">{dt.getTime() < midnight ? StampTODate(dt) + " " + DAY[dt.getDay()] : "Today"}</div>
                <Table style={{ borderTop: "hidden", marginTop: "1%", marginBottom: "0px" }}>
                  <tbody>
                    <tr>
                      <td align="center" className="color-9b9b9b font-size14px" style={{ width: "30%", borderBottom: "hidden" }}>Distance<div className="font-size18px" style={{ color: "black" }}>{stat.dst ? (stat.dst / 1000).toFixed(2) + " Km" : "-"}</div></td>
                      <td align="center" className="color-9b9b9b font-size14px" style={{ width: "30%" }}>Duration<div className="font-size18px" style={{ color: "black" }}>{stat.dur ? parseMSIntoReadableTime(stat.dur * 1000) : "-"}</div></td>
                      <td align="center" className="color-9b9b9b font-size14px" style={{ width: "40%" }}>Engine On Duration<div className="font-size18px" style={{ color: "black" }}>{stat.ignOnDur ? parseMSIntoReadableTime(stat.ignOnDur * 1000) : "-"}</div></td>
                    </tr>
                  </tbody>
                </Table>
              </div>
          });
      });
    }
  }

  onTileClick = (stats) => {
    this.props.onTileClick(stats);
  }

  render() {
    return (
      <Row className=" col-lg-offset-1 col-lg-10 col-md-offset-1 col-md-10 col-sm-offset-1 col-sm-10 col-xs-offset-1 col-xs-10 overflowY-auto" style={{ height: 'inherit'}}>
        {
          this.dailyStatsTiles.length ?
            this.dailyStatsTiles.map((stats, i) => {
              return (
                <ListGroupItem style={{ position: "initial", marginBottom: "2%", borderRadius: "4px", align: "center" }} header={stats.table} key={i} onClick={() => this.onTileClick(stats.stat)}></ListGroupItem>
              )
            })
            : null
        }
      </Row>
    )
  }
}